import { insertDatePicker } from './insertDatePicker';
import { insertTimeRangePicker } from './insertTimeRangePicker';
import { controlProductCart } from './controlProductCart';
import { controlSalesPeriod } from './controlSalesPeriod';
const main = () => {
  document.addEventListener('DOMContentLoaded', () => {
    insertDatePicker();
    controlSalesPeriod();
    // insertTimeRangePicker();
    // controlProductCart();
  });
};
main();
